import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/hubTextOverlay/hubTextOverlay.js';
import s from 'components/bolt/hub/components/hubTextOverlay/hubTextOverlay.sss';
import { joinClasses } from 'utils/utils';
import HTML from 'components/core/html/html';
import Close from 'components/bolt/icons/close';

export default class HubTextOverlay extends BaseComp.default {
	render({ content, show, closeOverlay }) {
		const { title, src, subtitle1, text1, subtitle2, text2 } = content;

		return (
			<div class={joinClasses(s.container, (show || this.state.isClosing) && s.show)}>
				<div class={s.bgGradient} onClick={closeOverlay} />
				<div class={s.content}>
					<div class={s.desktopSplit}>
						{src && (
							<div class={s.overlayImage}>
								<img src={src} />
							</div>
						)}
						<div class={s.details}>
							<h1>{title}</h1>
							{this.props.isFilm ? (
								<div class={s.textContent}>
									<h2>{subtitle1}</h2>
									<p>{text1}</p>
									<h2>{subtitle2}</h2>
									<p>{text2}</p>
								</div>
							) : (
								<div class={s.jaquelineColey} dangerouslySetInnerHTML={{ __html: content }} />
							)}
						</div>
					</div>
				</div>
				<button class={s.closeBtn} onClick={closeOverlay}>
					<Close class={s.close} />
				</button>
			</div>
		);
	}
}